import SectionHeading from '../common/SectionHeading';

const steps = [
  {
    title: 'Intake',
    text: 'Send the equipment type, photos, nameplate details, symptoms, and location so we can understand the request.',
  },
  {
    title: 'Pickup or Shipment',
    text: 'We arrange pickup or shipping so the equipment can be reviewed properly in person.',
  },
  {
    title: 'Inspection & Quote',
    text: 'Once the component is received, we inspect it, confirm the repair scope, and provide the quote before work moves ahead.',
  },
  {
    title: 'Repair & Return',
    text: 'After approval, we complete the repair, run practical checks, and return the equipment.',
  },
];

function RepairProcess() {
  return (
    <section className="repair-process" aria-labelledby="repair-process-title">
      <div className="container">
        <SectionHeading
          eyebrow="How Repair Works"
          title="A clear path from problem to repair"
          text="Industrial downtime needs a direct process: understand the request, get the equipment in hand, confirm the repair scope, and return it to service."
        />
        <div className="repair-process__grid">
          {steps.map((step, index) => (
            <article key={step.title} className="repair-process__step">
              <span>{String(index + 1).padStart(2, '0')}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RepairProcess;
